import React from "react";
import { Link } from "react-router-dom";
import Card from "react-bootstrap/Card";
import TrackImage from "~/Components/Elements/Global/TrackImage";

const PlaylistCard = ({ p }) => (
  <Link to={`/playlist/${p.id}`} className={`playlistCardHover${Number(p.collaborative) === 1 ? " is-collaborative" : ""}`}>
    <Card>
      <div className="playlistCoverGrid">
        {p.covers &&
          p.covers.length > 0 &&
          p.covers.map((c, index) => (
            <div id={`cover-${index}`} className="gridCover">
              <TrackImage track={c} width={null} link={false} />
            </div>
          ))}
      </div>
      <Card.Body>
        <Card.Title className="titleText">
          {p.name}
          {Number(p.collaborative) === 1 && <span className="playlistCollabBadge">Collaborative</span>}
          {Number(p.favorited) === 1 && <span className="playlistFavoriteBadge">Favorited</span>}
        </Card.Title>
        {p.total > 0 && (
          <Card.Text>
            ({p.total} Track{p.total === 1 ? `` : `s`})
          </Card.Text>
        )}
        <Card.Text className="subText">{p.description}</Card.Text>
        {p.chimName || p.userName ? (
          <Card.Text className="subText author">Created by: {p.chimName ? `${p.chimName} Chimney` : p.userName}</Card.Text>
        ) : null}
      </Card.Body>
    </Card>
  </Link>
);

PlaylistCard.propTypes = {
  // bla: PropTypes.string,
};

PlaylistCard.defaultProps = {
  // bla: 'test',
};

export default PlaylistCard;
